import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import MultiSelect from '../common/MultiSelect';
import TagInput from '../portfolio/TagInput';
import ImageUpload from '../common/ImageUpload';
import useMaster from '../../hooks/useMaster';

const SortDataForm = ({ data, onChange, onTagsChange, submitted }) => {
  const industries = useMaster('industry');
  const revenueGoals = useMaster('revenue-goal');
  const capabilities = useMaster('capability');
  const businessProblems = useMaster('business-problem');

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label>Listing Image <span className="font-normal text-xs text-gray-400">(575 × 767 px)</span><span className="text-red-500">*</span></Label>
        <ImageUpload
          value={data.image}
          onChange={(val) => onChange(prev => ({ ...prev, image: val }))}
          error={!data.image && submitted}
        />
        {(!data.image && submitted) && <p className="text-xs text-red-500 font-medium">Listing Image is required.</p>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Listing Title <span className="text-red-500">*</span></Label>
          <Input
            value={data.title}
            className={(!data.title && submitted) ? "border-red-500 focus-visible:ring-red-500" : ""}
            onChange={(e) => onChange(prev => ({ ...prev, title: e.target.value }))}
            placeholder="Title shown in cards"
          />
        </div>
        <div className="space-y-2">
          <Label>Listing Subtitle <span className="text-red-500">*</span></Label>
          <Input
            value={data.sub_title}
            className={(!data.sub_title && submitted) ? "border-red-500 focus-visible:ring-red-500" : ""}
            onChange={(e) => onChange(prev => ({ ...prev, sub_title: e.target.value }))}
            placeholder="Subtitle shown in cards"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Tags</Label>
        <TagInput tags={data.tags} setTags={onTagsChange} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Industry</Label>
          <MultiSelect
            options={industries.data}
            value={Array.isArray(data.industry_id) ? data.industry_id : []}
            onChange={(val) => onChange(prev => ({ ...prev, industry_id: val }))}
            placeholder="Select Industries"
          />
        </div>
        <div className="space-y-2">
          <Label>Revenue Goal</Label>
          <MultiSelect
            options={revenueGoals.data}
            value={Array.isArray(data.revenue_goal_id) ? data.revenue_goal_id : []}
            onChange={(val) => onChange(prev => ({ ...prev, revenue_goal_id: val }))}
            placeholder="Select Goals"
          />
        </div>
        <div className="space-y-2">
          <Label>Capability</Label>
          <MultiSelect
            options={capabilities.data}
            value={Array.isArray(data.capability_id) ? data.capability_id : []}
            onChange={(val) => onChange(prev => ({ ...prev, capability_id: val }))}
            placeholder="Select Capabilities"
          />
        </div>
        <div className="space-y-2">
          <Label>Business Problem</Label>
          <MultiSelect
            options={businessProblems.data}
            value={Array.isArray(data.business_problem_id) ? data.business_problem_id : []}
            onChange={(val) => onChange(prev => ({ ...prev, business_problem_id: val }))}
            placeholder="Select Problems"
          />
        </div>
      </div>
    </div>
  );
};

export default SortDataForm;
